const ac = new (window.AudioContext || window.webkitAudioContext)();

class Sound {
  constructor(context, type = 'sine') {
    this.context = context;
    this.duration = 1
    this.type = type
  }

  setup() {
    this.oscillator = this.context.createOscillator();
    this.gainNode = this.context.createGain();

    this.oscillator.connect(this.gainNode);
    this.gainNode.connect(this.context.destination);
    this.oscillator.type = this.type;
  }

  play(value) {
    this.setup();

    this.oscillator.frequency.value = value;
    this.gainNode.gain.setValueAtTime(0, this.context.currentTime);
    this.gainNode.gain.linearRampToValueAtTime(0.1, this.context.currentTime + 0.01);

    this.oscillator.start(this.context.currentTime);
    this.stop();
  }

  stop() {
    this.gainNode.gain.exponentialRampToValueAtTime(0.001, this.context.currentTime + this.duration);
    this.oscillator.stop(this.context.currentTime + this.duration);
    // cleanup
    this.oscillator.onended = () => {
      this.oscillator.disconnect();
      this.gainNode.disconnect();
    }
  }
}

export function xylo(pitch = 440) {
  let sound = new Sound(ac);
  sound.play(pitch);
}

export function errorSound(pitch = 440) {
  let sound = new Sound(ac, 'square');
  sound.play(pitch);
}
